import styled from '@emotion/styled'
import AntRadio from 'antd/lib/radio'

export const Radio = styled(AntRadio)<{
  hasInput?: boolean
  hasWordWrap?: boolean
}>`
  ${({ hasInput, hasWordWrap }) =>
    `
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  min-height: 48px;

  padding: 8px 12px;
  border-radius: 6px;
  border: 1px solid #d2d2d9;

  &.ant-radio-wrapper {
    background: white;
  }

  &.ant-radio-wrapper-checked {
    border-color: #4a4a68;
    background: #fafafb;
  }

  .ant-radio {
    top: 0;
  }

  ::after {
    display: none;
  }

  ${
    hasInput &&
    `
    &.ant-radio-wrapper-checked {
      .ant-input-affix-wrapper, .ant-input-number-affix-wrapper {
        border-color: #4a4a68;
        padding-right: 8px;
      }
    }
  `
  }

  &.description-only {
    padding: 0;
  }

  > span:last-child {
    display: flex;
    flex-direction: ${hasInput ? 'row' : 'column'};
    ${hasInput && 'justify-content: space-between;'}
    ${hasInput && 'flex: 1;'}
    align-items: ${hasInput ? 'center' : 'flex-start'};
    gap: 4px;
    padding-right: 0px;

    strong {
      text-align: left;
      font-weight: 600;
      font-size: 14px;
      line-height: ${hasWordWrap ? '150%' : '100%'};
      letter-spacing: 5%;
      vertical-align: middle;
      text-transform: uppercase;
    }

    ${
      hasInput &&
      `
      .ant-input-affix-wrapper {
        padding-right: 8px;
      }
    `
    }

    span {
      text-align: left;
      font-weight: 400;
      font-size: 12px;
      line-height: 140%;
      letter-spacing: 5%;
      vertical-align: middle;
      color: #77778e;
    }
  }

  > span:last-child > span {
    padding-right: 0; 
  } 

  ${
    hasInput &&
    `
    .ant-form-item-control-input-content {
      display: flex;
      justify-content: flex-end;
    }

    .ant-form-item-explain.ant-form-item-explain-connected {
      margin: 0;
    }
  `
  }
  `}
`
